import { cn } from "./classNames-DcGnTh2N.js";
import { jsx } from "react/jsx-runtime";
//#region src/blocks/DiagramShared/DiagramSource.tsx
const DiagramSource = ({ code }) => /* @__PURE__ */ jsx("pre", {
	className: cn("tw:my-3 tw:overflow-auto tw:whitespace-pre-wrap tw:break-all", "tw:py-3 tw:px-4", "tw:bg-muted", "tw:rounded-md tw:text-muted-foreground", "tw:text-sm tw:font-mono"),
	children: /* @__PURE__ */ jsx("code", { children: code })
});
//#endregion
//#region src/blocks/DiagramShared/svgTransforms.ts
const HTML_TAG = /<[^>]+>/g;
const FOREIGN_OBJECT = /(<foreignObject\b[^>]*>)([\s\S]*?)(<\/foreignObject>)/g;
const ROOT_SVG_TAG = /^(\s*<svg\b)([^>]*)(>)/i;
/**
* Collapses each `<foreignObject>`'s HTML to its text content.
*
* - DOMPurify's SVG profile strips XHTML elements (mermaid labels vanish) but keeps bare text.
* - Mermaid already sanitized the text (`securityLevel: 'strict'`).
* - Entities stay encoded: decoding could turn `&lt;`/`&gt;` into real markup.
*/
const flattenForeignObjectLabels = (svg) => svg.replace(FOREIGN_OBJECT, (_match, open, inner, close) => {
	return `${open}${inner.replace(HTML_TAG, " ").replace(/\s+/g, " ").trim()}${close}`;
});
/**
* Makes the root `<svg>` fluid: `width="100%"`, `max-width` from the viewBox, no fixed height.
*
* - Only the root tag: inner icon `<svg>`s keep their fixed size.
* - Keeps `style` (minus `max-width`): beautiful-mermaid's `--bg`/`--fg` theme vars live there.
*/
const STYLE_ATTR = /\s+style="([^"]*)"/i;
const makeResponsive = (svgString) => {
	const viewBoxMatch = svgString.match(/viewBox="[^"]*\s([\d.]+)\s[\d.]+"/);
	const vbWidth = viewBoxMatch ? Math.round(Number(viewBoxMatch[1])) : void 0;
	return svgString.replace(ROOT_SVG_TAG, (_match, open, attrs, close) => {
		const styleDecls = (attrs.match(STYLE_ATTR)?.[1] ?? "").replace(/max-width:\s*[^;"]*;?\s*/gi, "").replace(/\s+/g, " ").trim().replace(/;$/, "");
		let nextAttrs = attrs.replace(/\s+width="[^"]*"/i, "").replace(/\s+height="[^"]*"/i, "").replace(STYLE_ATTR, "");
		nextAttrs += " width=\"100%\"";
		const styleParts = [styleDecls, vbWidth ? `max-width: ${vbWidth}px` : ""].filter(Boolean).join("; ");
		if (styleParts) nextAttrs += ` style="${styleParts}"`;
		return `${open}${nextAttrs}${close}`;
	});
};
/**
* Whether an SVG has drawn content, i.e. a non-degenerate viewBox.
*
* - beautiful-mermaid may return `viewBox="0 0 0 0"` instead of throwing; mermaid must then run.
* - A missing viewBox counts as drawn: some mermaid types size via width/height.
* - Only the root `<svg>` is read; nested icon `<svg>`s carry their own viewBox.
* - Any quote style and spaces around `=` match; a miss would count as drawn.
*/
const ROOT_VIEWBOX = /^\s*<svg\b[^>]*\sviewBox\s*=\s*(["'])\s*[\d.eE+-]+\s+[\d.eE+-]+\s+([\d.eE+-]+)\s+([\d.eE+-]+)\s*\1/i;
const hasDrawnContent = (svg) => {
	const viewBox = svg.match(ROOT_VIEWBOX);
	if (!viewBox) return true;
	return Number(viewBox[2]) > 0 && Number(viewBox[3]) > 0;
};
//#endregion
export { DiagramSource, flattenForeignObjectLabels, hasDrawnContent, makeResponsive };

//# sourceMappingURL=svgTransforms-CntOy_VY.js.map